import { initNavHover } from './nav-hover';
import { initAgentAutocomplete } from './agent-autocomplete';
import { initHeaderSearchAutocomplete } from './header-search-autocomplete';
import { initAvailabilityInfo } from './availability-info';

function initMinibasketDropdown(): void {
    document.querySelectorAll<HTMLInputElement>('.minibasket-dropdown__radio').forEach((radio) => {
        radio.addEventListener('change', () => {
            window.location.href = '?cl=woehnerbasketswitch&basketid=' + encodeURIComponent(radio.value);
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initNavHover();
    initAgentAutocomplete();
    initHeaderSearchAutocomplete();
    initMinibasketDropdown();
    initAvailabilityInfo();
});
